'use client';

import React from 'react';
import { MAX_CREDIT_CARDS_COUNT } from '../../../../consts/client-detail';
import { CardWithTooltip } from './CardWithTooltip';
import { SelectableCard } from './SelectableCard';
import type { CardsGroupPropsType, SelectableCardConfig } from './types';
import CreditCard from '/public/icons/credit-card-1.svg';
import User from '/public/icons/user.svg';

const CARDS_CONFIG: SelectableCardConfig[] = [
  {
    key: 'profile',
    title: 'Profile Form',
    icon: <User />,
    showTooltip: true,
  },
  {
    key: 'credit_card',
    title: 'Credit Card Form',
    icon: <CreditCard />,
  },
];

export function CardsGroup(props: CardsGroupPropsType) {
  const {
    isCreditCardsLimitReached,
    selectedForms,
    onToggle,
    isLoading = false,
    isSelectionInvalid = false,
    selectionErrorMessage,
  } = props;
  return (
    <div className="grid grid-cols-2 gap-4">
      {CARDS_CONFIG.map((card) => {
        const isLimitReached = isCreditCardsLimitReached && card.key === 'credit_card';
        const isSelected = selectedForms.includes(card.key);
        return (
          <CardWithTooltip
            key={card.key}
            show={isLimitReached}
            content={
              <>
                You’ve reached the {MAX_CREDIT_CARDS_COUNT}-cards <br />
                limit. Remove a card to send a <br />
                new form.
              </>
            }
          >
            <SelectableCard
              title={card.title}
              icon={card.icon}
              selected={isSelected}
              disabled={isLimitReached || isLoading}
              invalid={isSelectionInvalid}
              onClick={() => onToggle(card.key)}
            />
          </CardWithTooltip>
        );
      })}
      {isSelectionInvalid && selectionErrorMessage && (
        <p role="alert" className="sr-only">
          {selectionErrorMessage}
        </p>
      )}
    </div>
  );
}
